<script setup lang="ts">
const { columns } = defineProps({
    title: { type: String, default: undefined },
    columns: { type: String as PropType<'2' | '4'>, default: '4' },
});

const gridColsClass = computed(() => {
    if (columns === '2') {
        return 'md:grid-cols-2';
    }

    return 'md:grid-cols-4';
});
</script>

<template>
    <section class="space-y-3">
        <h4 v-if="!!title" class="font-semibold">{{ title }}</h4>
        <div class="space-y-3 md:grid md:gap-x-3 md:gap-y-6" :class="gridColsClass">
            <slot />
        </div>
    </section>
</template>
